// Recebe o SweetAlert da aplicação, sem instalar dependências dentro de shared.
export function confirmGridAction(Swal, options, source) {
  const previous = document.activeElement
  const keepFocus = event => { if (Swal.getContainer()?.contains(event.target)) event.stopImmediatePropagation() }
  return Swal.fire({
    icon: 'question', showCancelButton: true, focusCancel: true,
    cancelButtonText: 'Cancelar', returnFocus: false, keydownListenerCapture: true,
    ...options,
    didOpen() {
      const layers = [...document.querySelectorAll('.modal.show, .relationship-workspace')].map(el => Number(getComputedStyle(el).zIndex) || 0)
      for (let el = source; el; el = el.parentElement) layers.push(Number(getComputedStyle(el).zIndex) || 0)
      Swal.getContainer().style.zIndex = String(Math.max(1060, ...layers) + 20)
      const color = source && getComputedStyle(source).getPropertyValue('--color-theme').trim()
      if (color) Swal.getConfirmButton().style.backgroundColor = color
      Swal.getHtmlContainer().style.whiteSpace = 'pre-line'
      document.addEventListener('focusin', keepFocus, true)
    },
    willClose() { document.removeEventListener('focusin', keepFocus, true) },
    didClose() { if (previous?.isConnected) previous.focus({ preventScroll: true }) }
  }).then(result => result.isConfirmed)
}
